/*
 *  Document   : consultant_candidates.js
 *  Author     : Exapoint
 *
 */

// Import required modules
import ExaHelpers from "../exa_helpers";

export default class AdministratorConsultants {
    /*
    * Auto called when creating a new instance
    *
    */
    constructor() {
        window["AdministratorConsultants"] = this;
        this.init();
    }

    init() {
        $('.js-dataTable-full-pagination').DataTable({
            ajax: datatablesAjax,
            language: {
                url: Laravel.datatablesLanguage
            },
            columns: [
                {data: "user.id"},
                {
                    data: "user.full_name",
                    render: function (data, type, row) {
                        let removedBadge = row.user.deleted_at ? $('.removed-badge').html() : '';
                        let profilePictureUrl = row.user.profile_picture ? `${Laravel.app_url}/storage/${row.user.profile_picture}` : `${Laravel.app_url}/media/avatars/exa_avatar_placeholder.jpg`;
                        return `
                        <a href="${consultantsEditUrl.replace(':user-id', row.user.id)}" >
                            <div style="background-image: url('${profilePictureUrl}')" class="img-avatar img-avatar-thumb"></div>
                            <span class="px-2 avatar-name">${row.user.full_name}</span>
                            <br>${removedBadge}
                        </a>`;
                    }
                },
            ],
            drawCallback: function () { if (!this.api().data().length) $('.dataTables_paginate .pagination').css('visibility', 'hidden') },
            processing: true,
            serverSide: true,
            lengthChange: false,
            autoWidth: false,
            responsive: true
        });
    }
}
